import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

import { VBabyColors } from "./colors";

const PANEL_START = VBabyColors.primaryDefault;
const PANEL_END = VBabyColors.primaryDark;

const config = defineConfig({
  preflight: false,

  // O Chakra injeta este CSS no documento, não no escopo do React: sem neutralizar,
  // `html { color: fg; bg: bg }` repinta as telas em styled-components e MUI.
  globalCss: {
    html: { color: "inherit", bg: "transparent", lineHeight: "inherit" },
    "*::selection": { bg: VBabyColors.primaryDark, color: VBabyColors.white },
  },

  theme: {
    breakpoints: { lg: "961px" },

    tokens: {
      colors: {
        vbaby: {
          purple: { value: VBabyColors.primaryDark },
          light: { value: VBabyColors.primaryDefault },
          accent: { value: VBabyColors.primaryDark },
          lilac: { value: VBabyColors.primary10 },
          border: { value: VBabyColors.primary20 },
          onPanel: { value: VBabyColors.white },
          onPanelMuted: { value: VBabyColors.primary20 },

          ink: { value: VBabyColors.black },
          label: { value: VBabyColors.gray80 },
          text2: { value: VBabyColors.gray70 },
          text3: { value: VBabyColors.gray50 },
          muted: { value: VBabyColors.gray40 },

          canvas: { value: VBabyColors.secondaryDefault },
          card: { value: VBabyColors.white },
          danger: { value: VBabyColors.red },
          mint: { value: VBabyColors.gradientEnd },
          panel: { value: PANEL_END },
        },
      },
      fonts: {
        heading: { value: "'Poppins', sans-serif" },
        body: { value: "'Karla', sans-serif" },
        numeric: { value: "'Archivo', sans-serif" },
      },
    },
    keyframes: {
      vbabyPulse: {
        "0%, 100%": { opacity: 0.25 },
        "50%": { opacity: 1 },
      },
    },
  },
});

export const vbabySystem = createSystem(defaultConfig, config);

export const EMOTION_PANEL_BG = `radial-gradient(circle at 45% 35%, ${PANEL_START}, ${PANEL_END} 68%)`;

export const PIX_BUTTON_BG = `linear-gradient(135deg, ${VBabyColors.primaryDefault}, ${VBabyColors.primaryDark})`;

export const FOCUS_RING = "0 0 0 4px rgba(93, 77, 235, 0.12)";
